// import React from 'react';
// import PropTypes from 'prop-types';
// import SimpleBarReact from 'simplebar-react';
// import { Table } from 'react-bootstrap';
// import classNames from 'classnames';
// import moment from 'moment';

// const getTotal = (data, key) =>
//   data.reduce((acc, val) => acc + Number(val[key]), 0);

//   // date: '30.10.2023',
//   // totalSupportCalls: 10,
//   // resolved: 9,
//   // permanentlyResolved: 7,
//   // temporaryResolved: 2,
//   // pending:1


// const TableRow = ({ item, isLast }) => {
//   return (
//     <tr>
//       <td
//         className={classNames(
//           'align-middle font-sans-serif fw-medium text-nowrap',
//           {
//             'border-bottom-0': isLast
//           }
//         )}
//       >
//         {item.date}
//       </td>
//       <td
//         className={classNames('align-middle text-center', {
//           'border-bottom-0': isLast
//         })}
//       >
//         {item.totalSupportCalls}
//       </td>
//       <td
//         className={classNames('align-middle text-center', {
//           'border-bottom-0': isLast
//         })}
//       >
//         {item.resolved}
//       </td>
//       <td
//         className={classNames('align-middle text-center', {
//           'border-bottom-0': isLast
//         })}
//       >
//         {item.permanentlyResolved}
//       </td>
//       <td
//         className={classNames('align-middle text-center', {
//           'border-bottom-0': isLast
//         })}
//       >
//         {item.temporaryResolved}
//       </td>
//       <td
//         className={classNames('align-middle text-center', {
//           'border-bottom-0': isLast
//         })}
//       >
//         {item.pending}
//       </td>
//     </tr>
//   );
// };

// const SupportServicesTable = ({ data }) => {
//   return (
//     <SimpleBarReact>
//       <Table className="fs--1 mb-0">
//         <thead className="bg-200 text-800">
//           <tr>
//             <th className="text-nowrap">Date</th>
//             <th className="text-nowrap text-center">Total Support Tickets</th>
//             <th className="text-nowrap text-center">Resolved</th>
//             <th className="text-nowrap text-center">Permanently Resolved</th>
//             <th className="text-nowrap text-center">Temporary  Resolved</th>
//             <th className="text-nowrap text-center">Pending</th>
//           </tr>
//         </thead>
//         <tbody>
//           {data.map((item, index) => (
//             <TableRow
//               key={item.id}
//               item={item}
//               isLast={data.length - 1 === index}
//             />
//           ))}
//         </tbody>
//         <tfoot className="bg-light">
//           <tr className="text-700 fw-bold">
//             <th>Total</th>
//             <th className="text-center">{getTotal(data, 'totalSupportCalls')}</th>
//             <th className="text-center">{getTotal(data, 'resolved')}</th>
//             <th className="text-center">{getTotal(data, 'permanentlyResolved')}</th>
//             <th className="pe-x1 text-center">{getTotal(data, 'temporaryResolved')}</th>
//             <th className="pe-x1 text-center">{getTotal(data, 'pending')}</th>
//           </tr>
//         </tfoot>
//       </Table>
//     </SimpleBarReact>
//   );
// };


// export default SupportServicesTable;








import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import SimpleBarReact from 'simplebar-react';
import { Table, Pagination } from 'react-bootstrap';
import classNames from 'classnames';
import moment from 'moment';
import AppContext from 'context/Context';

const getTotal = (data, key) =>
  data.reduce((acc, val) => acc + Number(val[key]), 0);

  const TableRow = ({ item, isLast, textColor }) => {
    return (
      <tr>
        <td
          className={classNames(
            'align-middle font-sans-serif fw-medium text-nowrap',
            {
              'border-bottom-0': isLast
            }
          )}
          style={{ color: textColor }}
        >
          {item.date}
        </td>
        <td
          className={classNames('align-middle text-center', {
            'border-bottom-0': isLast
          })}
          style={{ color: textColor }}
        >
          {item.totalSupportCalls}
        </td>
        <td
          className={classNames('align-middle text-center', {
            'border-bottom-0': isLast
          })}
          style={{ color: textColor }}
        >
          {item.resolved}
        </td>
        <td
          className={classNames('align-middle text-center', {
            'border-bottom-0': isLast
          })}
          style={{ color: textColor }}
        >
          {item.permanentlyResolved}
        </td>
        <td
          className={classNames('align-middle text-center', {
            'border-bottom-0': isLast
          })}
          style={{ color: textColor }}
        >
          {item.temporaryResolved}
        </td>
        <td
          className={classNames('align-middle text-center', {
            'border-bottom-0': isLast
          })}
          style={{ color: textColor }}
        >
          {item.pending}
        </td>
      </tr>
    );
  };

const SupportServicesTable = ({ data }) => {
  const [showAll, setShowAll] = useState(false);
  const { config } = useContext(AppContext);
  const { isDark } = config;
  // Filter out rows where all main columns are zero
  const filteredData = data.filter(item => {
    return (
      Number(item.totalSupportCalls) !== 0 ||
      Number(item.resolved) !== 0 ||
      Number(item.permanentlyResolved) !== 0 ||
      Number(item.temporaryResolved) !== 0 ||
      Number(item.pending) !== 0
    );
  });
  const displayData = showAll ? data : filteredData;
  const pageSize = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const lastItemIndex = currentPage * pageSize;
  const firstItemIndex = lastItemIndex - pageSize;
  const currentData = displayData.slice(firstItemIndex, lastItemIndex);

  const textColor = isDark ? '#f8f9fa' : '#212529';
  const headerBg = isDark ? '#23272b' : undefined;
  const footerBg = isDark ? '#23272b' : undefined;
  const tableBg = isDark ? '#181a1b' : '#fff';

  const handlePaginationClick = page => {
    setCurrentPage(page);
  };

  return (
    <div>
      <SimpleBarReact>
        <Table className="fs--1 mb-0" >
          <thead className="bg-200 text-800" >
            <tr>
              <th colSpan={6} style={{ background: 'inherit', padding: 0, color: textColor }}>
                <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                  <button
                    className={`btn btn-sm ${showAll ? 'btn-success' : 'btn-outline-secondary'}`}
                    style={{ minWidth: 110, fontWeight: 500, margin: 4 }}
                    onClick={() => setShowAll(v => !v)}
                  >
                    {showAll ? 'Hide 0 Rows' : 'Show All Rows'}
                  </button>
                </div>
              </th>
            </tr>
            <tr>
              <th className="text-nowrap" style={{ color: textColor }}>Company</th>
              <th className="text-nowrap text-center" style={{ color: textColor }}>Total Support Tickets</th>
              <th className="text-nowrap text-center" style={{ color: textColor }}>Resolved</th>
              <th className="text-nowrap text-center" style={{ color: textColor }}>Permanently Resolved</th>
              <th className="text-nowrap text-center" style={{ color: textColor }}>Temporary  Resolved</th>
              <th className="text-nowrap text-center" style={{ color: textColor }}>Pending</th>
            </tr>
          </thead>
          <tbody>
            {currentData.map((item, index) => (
              <TableRow
                key={item.id}
                item={item}
                isLast={currentData.length - 1 === index}
                textColor={textColor}
              />
            ))}
          </tbody>
          <tfoot className="bg-light" >
            <tr className="text-700 fw-bold">
              <th style={{ color: textColor }}>Total</th>
              <th className="text-center" style={{ color: textColor }}>{getTotal(displayData, 'totalSupportCalls')}</th>
              <th className="text-center" style={{ color: textColor }}>{getTotal(displayData, 'resolved')}</th>
              <th className="text-center" style={{ color: textColor }}>{getTotal(displayData, 'permanentlyResolved')}</th>
              <th className="pe-x1 text-center" style={{ color: textColor }}>{getTotal(displayData, 'temporaryResolved')}</th>
              <th className="pe-x1 text-center" style={{ color: textColor }}>{getTotal(displayData, 'pending')}</th>
            </tr>
          </tfoot>
        </Table>
      </SimpleBarReact>
      <Pagination className="justify-content-center mt-3">
        {Array.from({ length: Math.ceil(displayData.length / pageSize) }).map((_, index) => (
          <Pagination.Item
            key={index}
            active={index + 1 === currentPage}
            onClick={() => handlePaginationClick(index + 1)}
          >
            {index + 1}
          </Pagination.Item>
        ))}
      </Pagination>
    </div>
  );
};

SupportServicesTable.propTypes = {
  data: PropTypes.array.isRequired
};

export default SupportServicesTable;
